import { MAILTO_EMPTY_LINE, MAILTO_LINE_BREAK, PRODUCT_TEAM_EMAIL } from './constants'

import type { UserCurrentWorkspace } from 'features/user/types/user'
import type { TFunction } from 'i18next'

type SuggestFeatureWorkspace = Pick<UserCurrentWorkspace, 'name' | 'networkCode'>

export const getSuggestFeatureMailto = (
  t: TFunction<'features/layout', 'helpMenu'>,
  workspace?: SuggestFeatureWorkspace,
): string => {
  const interpolation = { escapeValue: false }

  const subject: string = workspace
    ? t('suggestFeature.email.subjectWithWorkspace', {
        interpolation,
        workspaceName: workspace.name,
      })
    : t('suggestFeature.email.subject')

  const workspaceData: string[] = workspace
    ? [
        t('suggestFeature.email.workspace', {
          interpolation,
          networkCode: workspace.networkCode,
          workspaceName: workspace.name,
        }),
      ]
    : []

  const body: string = [
    ...workspaceData,
    MAILTO_EMPTY_LINE,
    MAILTO_EMPTY_LINE,
    t('suggestFeature.email.problem'),
    MAILTO_EMPTY_LINE,
    MAILTO_EMPTY_LINE,
    t('suggestFeature.email.solution'),
    MAILTO_EMPTY_LINE,
    MAILTO_EMPTY_LINE,
  ].join(MAILTO_LINE_BREAK)

  return `mailto:${PRODUCT_TEAM_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}
